var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "currentColor",
    d: "M18.357 12.728c.033 3.525 3.093 4.699 3.127 4.714-.026.082-.49 1.671-1.612 3.313-.971 1.419-1.98 2.832-3.566 2.862-1.56.028-2.061-.925-3.845-.925-1.783 0-2.34.895-3.816.953-1.532.058-2.7-1.534-3.678-2.948-2-2.892-3.53-8.172-1.476-11.736 1.02-1.77 2.842-2.89 4.82-2.92 1.504-.028 2.924 1.012 3.844 1.012s2.645-1.251 4.459-1.068c.76.032 2.891.307 4.26 2.311-.11.069-2.543 1.485-2.517 4.432m-2.931-8.656c.813-.984 1.36-2.355 1.212-3.719-1.173.047-2.59.781-3.432 1.766-.754.87-1.414 2.266-1.236 3.603 1.307.1 2.642-.665 3.456-1.65"
  })));
};
export default SvgApple;